import Http from "@/utils/http";
const baseUrl = "/app/student";

/**
 * 团队列表
 * @param params
 *
 */

export const teamList = (params) => Http.get(`${baseUrl}/team`, { params });

/**
 * 团队详情
 * @param teamId
 *
 */

export const teamDetail = (teamId) => Http.get(`${baseUrl}/team/${teamId}`);

/**
 * 我的团队
 *
 */

export const myTeam = (params) => Http.get(`${baseUrl}/team/info`, { params });

/**
 * 创建团队
 * @param params
 *
 */

export const addTeam = (params) => Http.post(`${baseUrl}/team`, params);

/**
 * 申请加入
 * @param params
 *
 */

export const joinTeam = (params) => Http.post(`${baseUrl}/team/join`, params);

/**
 * 团队成员列表
 * @param classId
 *
 */

export const memberList = (classId) =>
  Http.get(`${baseUrl}/team/user/${classId}`);

/**
 * 审核团队成员(仅队长)
 * @param params
 *
 */

export const verifyMember = (params) =>
  Http.put(`${baseUrl}/team/user`, params);

/**
 * 解散团队(仅队长)
 *
 */

export const delTeam = () => Http.delete(`${baseUrl}/team`);

/**
 * 删除团队成员
 * @param teamUserId
 *
 */

export const delMember = (teamUserId) =>
  Http.delete(`${baseUrl}/team/user/${teamUserId}`);

/**
 * 编辑团队(仅队长)
 *
 */

export const editTeam = (params) => Http.put(`${baseUrl}/team`, params);

/**
 * 获取抖音授权码
 * @param params
 *
 */

export const getTiktokCode = (params) =>
  Http.get(`${baseUrl}/team/douyinAuthCode`, { params });

/**
 * 授权码状态
 * @param params
 *
 */

export const tiktokCodeState = (params) =>
  Http.get(`${baseUrl}/team/douyinAuthCode/state`, { params });

/**
 * 抖音列表
 * @param params
 *
 */

export const tiktokList = (params) =>
  Http.get(`${baseUrl}/team/douyin`, { params });

/**
 * 取消抖音授权
 * @param params
 *
 */

export const cancelBinding = (params) =>
  Http.get(`${baseUrl}/team/cancelDouyinAuth`, { params });

/**
 * 取消快手授权
 * @param params
 *
 */

export const cancelBindingKuaishou = (params) =>
  Http.get(`${baseUrl}/team/cancelKuaishouAuth`, { params });

/**
 * 获取快手授权链接
 * @param {*} params
 * @returns
 */
export const getKuaishouAuthUrl = (params) =>
  Http.get(`${baseUrl}/team/kuaishouAuthUrl`, { params });

/**
 * 查询快手授权状态
 * @param {*} params
 * @returns
 */
export const getKuaishouAuthState = (params) =>
  Http.get(`${baseUrl}/team/kuaishouAuthState`, { params });

/**
 * 快手列表
 * @param params
 *
 */

export const kuaishouList = (params) =>
  Http.get(`${baseUrl}/team/kuaishou`, { params });
